/**
 * API Calls to Get Category Data
 */
import 'whatwg-fetch';

export default class Data {
	constructor(termIds, resourceType, page) {
		this.endpoint = '';
		this.restUrl = '';
		this.nonce = '';
		this.page = page;
		this.termIds = termIds;
		this.resourceType = resourceType;
	}

	/**
	 * Fetch all category data from Rest API.
	 */
	async fetch(callback) {
		const valid = this.validate();

		if (valid) {
			this.endpoint = `${this.restUrl}em-resource/v1/posts`;
			try {
				if (!this.resourceType.length) {
					throw new Error('Resource Type not defined. Please check your codes. Thanks.');
				}

				const response = await fetch(this.endpoint, {
					method: 'POST',
					body: JSON.stringify({
						resource_type: this.resourceType,
						term_ids: this.termIds,
						page: this.page,
					}),
					headers: {
						'Content-Type': 'application/json',
						'X-WP-Nonce': this.nonce,
					},
				});
				const json = await response.json();
				const { data, count, page } = json;
				callback(data, count, page);
				return true;
			} catch (error) {
				console.error('Error: ', error);
				return false;
			}
		} else {
			console.error('EmValidate access attempt invalid.');
			return false;
		}
	}

	validate() {
		const { EmValidate } = window;
		if (!EmValidate) {
			console.error('Error: ', 'EmValidate not found.');
			return false;
		}
		if (!EmValidate.restUrl) {
			console.error('Error: ', 'EmValidate.resturl not found.');
			return false;
		}

		this.restUrl = EmValidate.restUrl;
		this.nonce = EmValidate.nonce;

		return true;
	}
}
